/* Description « story » (section eiken-product-story, 09/10/2026).
   Amélioration progressive : sans JS, tout le texte reste lisible (résumé cabine, détails, FAQ). */
(function () {
  'use strict';

  function fmt(str, cm) { return String(str).replace('[cm]', cm); }
  // Les chaînes passent par | t : apostrophes encodées en entités HTML, on les décode.
  function dec(str) { var ta = document.createElement('textarea'); ta.innerHTML = str; return ta.value; }

  function initCabin(root) {
    var i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-eps-i18n]').textContent); } catch (e) { return; }
    Object.keys(i18n).forEach(function (k) { i18n[k] = dec(i18n[k]); });
    var hMin = +root.dataset.hMin, hMax = +root.dataset.hMax, w = +root.dataset.w, d = +root.dataset.d;
    var rollBtns = root.querySelectorAll('[data-eps-roll]');
    var gaugeBtns = root.querySelectorAll('[data-eps-gauge]');
    var imgs = root.querySelectorAll('[data-eps-size-img]');
    var vol = root.querySelector('[data-eps-vol]');
    var verdict = root.querySelector('[data-eps-verdict]');
    var scheme = root.querySelector('[data-eps-scheme]');
    if (!gaugeBtns.length || !verdict) return;
    var state = { roll: 'min', gauge: null };
    gaugeBtns.forEach(function (b) { if (b.getAttribute('aria-checked') === 'true') state.gauge = b; });
    if (!state.gauge) { state.gauge = gaugeBtns[0]; }

    function judge(bag, lim) {
      var diff = bag - lim;
      if (diff < 0) return { lvl: 0, icon: '✓', text: fmt(i18n.row_margin, -diff), color: 'var(--eps-ok)' };
      if (diff === 0) return { lvl: 1, icon: '!', text: i18n.row_limit, color: 'var(--eps-tight)', tight: true };
      if (diff <= 1) return { lvl: 1, icon: '!', text: fmt(i18n.row_soft, diff), color: 'var(--eps-tight)', soft: true };
      return { lvl: 2, icon: '✕', text: fmt(i18n.row_over, diff), color: 'var(--eps-no)' };
    }

    function pct(v, ref) { return Math.min(100, v / ref * 100).toFixed(1) + '%'; }

    function render() {
      var g = state.gauge.dataset;
      var bag = { h: state.roll === 'max' ? hMax : hMin, w: w, d: d };
      var lim = { h: +g.h, w: +g.w, d: +g.d };
      var rows = [['height', bag.h, lim.h], ['width', bag.w, lim.w], ['depth', bag.d, lim.d]].map(function (r) {
        var j = judge(r[1], r[2]); j.label = i18n[r[0]]; j.bag = r[1]; j.lim = r[2]; return j;
      });
      var worst = Math.max.apply(null, rows.map(function (r) { return r.lvl; }));
      var anySoft = rows.some(function (r) { return r.soft; }), anyTight = rows.some(function (r) { return r.tight; });
      var v;
      if (worst === 2) v = { t: i18n.no_fit, x: i18n.text_no, c: 'var(--eps-no)', i: '✕' };
      else if (anySoft) v = { t: i18n.fits_soft, x: i18n.text_soft, c: 'var(--eps-tight)', i: '!' };
      else if (anyTight) v = { t: i18n.fits_tight, x: i18n.text_tight, c: 'var(--eps-tight)', i: '!' };
      else v = { t: i18n.fits, x: i18n.text_fits, c: 'var(--eps-ok)', i: '✓' };

      verdict.style.setProperty('--eps-v', v.c);
      verdict.querySelector('[data-eps-v-icon]').textContent = v.i;
      verdict.querySelector('[data-eps-v-title]').textContent = v.t;
      verdict.querySelector('[data-eps-v-text]').textContent = v.x;
      var tbody = verdict.querySelector('[data-eps-v-rows]');
      tbody.textContent = '';
      rows.forEach(function (r) {
        var tr = document.createElement('tr');
        [r.label, r.bag + ' cm', r.lim + ' cm'].forEach(function (c) { var td = document.createElement('td'); td.textContent = c; tr.appendChild(td); });
        var res = document.createElement('td');
        res.style.color = r.color;
        var ic = document.createElement('span'); ic.setAttribute('aria-hidden', 'true'); ic.textContent = r.icon + ' ';
        res.appendChild(ic); res.appendChild(document.createTextNode(r.text));
        tr.appendChild(res); tbody.appendChild(tr);
      });
      verdict.hidden = false;

      if (scheme) {
        var f = function (sel) { return scheme.querySelector(sel); };
        f('[data-eps-s-face-bag]').style.cssText = 'width:' + pct(bag.w, 60) + ';height:' + pct(bag.h, 60);
        f('[data-eps-s-face-gauge]').style.cssText = 'width:' + pct(lim.w, 60) + ';height:' + pct(lim.h, 60);
        f('[data-eps-s-side-bag]').style.cssText = 'width:' + pct(bag.d, 30) + ';height:' + pct(bag.h, 60);
        f('[data-eps-s-side-gauge]').style.cssText = 'width:' + pct(lim.d, 30) + ';height:' + pct(lim.h, 60);
        scheme.hidden = false;
      }

      rollBtns.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.epsRoll === state.roll ? 'true' : 'false'); });
      gaugeBtns.forEach(function (b) { b.setAttribute('aria-checked', b === state.gauge ? 'true' : 'false'); });
      imgs.forEach(function (im) { im.hidden = im.dataset.epsSizeImg !== state.roll; });
      if (vol) vol.textContent = state.roll === 'max' ? vol.dataset.max : vol.dataset.min;
    }

    rollBtns.forEach(function (b) { b.addEventListener('click', function () { state.roll = b.dataset.epsRoll; render(); }); });
    gaugeBtns.forEach(function (b) { b.addEventListener('click', function () { state.gauge = b; render(); }); });
    // Flèches clavier dans chaque groupe radio
    root.querySelectorAll('[role=radiogroup]').forEach(function (grp) {
      grp.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
        var btns = Array.prototype.slice.call(grp.querySelectorAll('[role=radio]'));
        var i = btns.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault();
        var n = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : btns.length - 1)) % btns.length];
        n.focus(); n.click();
      });
    });
    render();
  }

  function initDetails(root) {
    var stage = root.querySelector('[data-eps-detail-img]');
    if (!stage) return;
    var btns = root.querySelectorAll('.eps-detail');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!b.dataset.src) return;
        stage.removeAttribute('srcset');
        stage.src = b.dataset.src;
        stage.alt = b.dataset.alt || '';
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      });
    });
  }

  // Module « Votre ordinateur rentre ? » : un verdict par appareil, rendu côté serveur ; on affiche celui choisi.
  function initLaptop(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-eps-dev]'));
    var answers = root.querySelectorAll('[data-eps-ans]');
    function pick(b) {
      btns.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); o.tabIndex = o === b ? 0 : -1; });
      answers.forEach(function (a) { a.hidden = a.dataset.epsAns !== b.dataset.epsDev; });
    }
    // Sur mobile, la réponse tombe souvent sous l'écran (sous le pouce) : on remonte juste assez pour la montrer.
    function reveal(b) {
      var a = root.querySelector('[data-eps-ans="' + b.dataset.epsDev + '"]');
      if (!a) return;
      var over = a.getBoundingClientRect().bottom - (window.innerHeight - 24);
      if (over <= 0) return;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: over, behavior: still ? 'auto' : 'smooth' });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { pick(b); reveal(b); });
      b.addEventListener('keydown', function (e) {
        var k = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key); if (k < 0) return;
        e.preventDefault();
        var n = btns[(btns.indexOf(b) + (k < 2 ? 1 : btns.length - 1)) % btns.length];
        n.focus(); pick(n);
      });
    });
    var cur = btns.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || btns[0];
    if (cur) pick(cur);
  }

  // Module « Dans la gamme » : sur mobile (liste qui défile), ouvrir sur la carte du modèle consulté.
  function initModels(list) {
    var c = list.querySelector('.eps-model--current');
    if (!c || list.scrollWidth <= list.clientWidth) return;
    var pad = parseInt(getComputedStyle(list).scrollPaddingLeft, 10) || parseInt(getComputedStyle(list).paddingLeft, 10) || 0;
    list.scrollLeft = Math.max(0, c.offsetLeft - list.offsetLeft - pad);
  }

  // Première question de FAQ : ouverte sur ordinateur, repliée sur mobile.
  function initFolds() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('[data-eps-mclose]').forEach(function (d) { d.open = false; });
  }

  // Fermeture des questions et du simulateur cabine : un <details> se referme
  // instantanément. On efface d'abord la réponse (.is-closing, 150 ms, CSS dans
  // eiken-story.css), puis on referme. L'ouverture reste en CSS seul.
  // Mouvement réduit : fermeture directe, comme avant.
  function initCloseFade() {
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Les questions (.e-faq) sont gérées par le snippet eiken-socle ; reste le simulateur cabine.
    document.querySelectorAll('.eps-sim').forEach(function (d) {
      var s = d.querySelector(':scope > summary');
      if (!s) return;
      s.addEventListener('click', function (e) {
        if (!d.open || reduit.matches) return;
        e.preventDefault();
        if (d.classList.contains('is-closing')) return;
        d.classList.add('is-closing');
        setTimeout(function () { d.classList.remove('is-closing'); d.open = false; }, 150);
      });
    });
  }

  // Module « Porté » : une carte par mannequin, plusieurs vues (profil, dos) en fondu.
  // À l'écran, les cartes tournent ensemble toutes les 3,2 s (même angle côte à côte) ;
  // au premier clic, la rotation s'arrête et la main passe au visiteur. Mouvement réduit : pas de rotation.
  function initViews(sec) {
    var figs = Array.prototype.slice.call(sec.querySelectorAll('[data-eps-views]'));
    if (!figs.length) return;
    var timer = null, stopped = false, cur = 0;
    function show(fig, i) {
      var imgs = fig.querySelectorAll('.eps-silh__view');
      var n = i % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === n); });
      fig.querySelectorAll('[data-eps-view-btn]').forEach(function (b, k) { b.setAttribute('aria-pressed', k === n ? 'true' : 'false'); });
      fig.dataset.epsCur = n;
    }
    function stop() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
    figs.forEach(function (fig) {
      fig.querySelectorAll('[data-eps-view-btn]').forEach(function (b, k) {
        b.addEventListener('click', function () { stop(); show(fig, k); });
      });
      fig.querySelector('.eps-silh__stack').addEventListener('click', function () {
        stop(); show(fig, (parseInt(fig.dataset.epsCur || '0', 10) + 1));
      });
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting;
      if (stopped) return;
      if (on && !timer) timer = setInterval(function () { cur++; figs.forEach(function (f) { show(f, cur); }); }, 3200);
      if (!on && timer) { clearInterval(timer); timer = null; }
    }, { threshold: 0.6 }).observe(sec.querySelector('.eps-silh__duo'));
  }

  // Bande « Porté » (module gallery, 27/10/2026, même logique que la galerie du récit Klättermusen / Topo) : flèches visibles à la
  // souris seulement (CSS), défilement de 80 % de la largeur, instantané si l'utilisateur réduit les animations ; flèches éteintes
  // aux deux bouts, masquées si tout tient sans défiler. Crochet visionneuse : chaque <li data-eps-gal-i> porte data-full.
  function initGallery(s) {
    var r = s.querySelector('.eps-gal__rail'), bs = s.querySelectorAll('[data-eps-gal-d]'), raf = 0;
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!r || bs.length < 2) return;
    function sync() {
      raf = 0; var x = Math.abs(r.scrollLeft), max = r.scrollWidth - r.clientWidth;
      bs[0].disabled = x < 4; bs[1].disabled = x > max - 4; s.classList.toggle('eps-gal--fit', max < 4);
    }
    r.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(sync); });
    bs.forEach(function (b) {
      b.addEventListener('click', function () { r.scrollBy({ left: (+b.getAttribute('data-eps-gal-d')) * r.clientWidth * 0.8, behavior: reduit.matches ? 'auto' : 'smooth' }); });
    });
    sync();
  }

  function init() {
    initFolds();
    initCloseFade();
    document.querySelectorAll('.eps-models__list').forEach(initModels);
    document.querySelectorAll('[data-eps-laptop]').forEach(initLaptop);
    document.querySelectorAll('[data-eps-cabin]').forEach(initCabin);
    document.querySelectorAll('[data-eps-details]').forEach(initDetails);
    document.querySelectorAll('.eps-silh').forEach(initViews);
    document.querySelectorAll('[data-eps-gal]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
